import type { PorchHeaderKeyMeasures } from "building-types/porches/porchKeyMeasuresTypes";
import { worldInchesNew } from "common/utils/nominalNumbers";
import { polyLine3Length } from "geom/polyLine3";
import type { ExteriorTrimCollectionBuilding, TrimKeyMeasure } from "../trimTypes";

export function getPorchHeaders(
  building: ExteriorTrimCollectionBuilding,
  trimKeyMeasures: TrimKeyMeasure[] = [],
): TrimKeyMeasure[] {
  if (!building) {
    return trimKeyMeasures;
  }

  const { porches, settings } = building;
  const materialSlot = settings.exteriorTrim?.porchHeaderTrimMaterial;

  const getPorchHeaderName = ({ width, depth }: PorchHeaderKeyMeasures): string => {
    return `Porch Header ${depth} x ${width}`;
  };

  for (const porchId in porches) {
    const { keyMeasures } = porches[porchId];
    const { headers } = keyMeasures;

    trimKeyMeasures.push(
      ...headers.map((header) => ({
        category: "PORCH_HEADER" as const,
        name: getPorchHeaderName(header),
        length: worldInchesNew(polyLine3Length(header.rail)),
        rail: header.rail,
        height: worldInchesNew(header.width),
        width: worldInchesNew(header.depth),
        materialSlot,
      })),
    );
  }

  return trimKeyMeasures;
}
